import React, { useState } from "react";
import { RangeSlider } from "rsuite";

interface Props {
  label: string;
  min: number;
  max: number;
  step: number;
  onChange: Function;
  value: [number, number];
}

export const EPRangeSlider: React.FC<Props> = ({
  label,
  min,
  max,
  step,
  onChange,
  value,
}) => {
  const renderSuffix = (value: number) => {
    switch (label) {
      case "Experience":
        return <span>{value} Year</span>;
      case "Salary":
        return <span>{value} LPA</span>;
      default:
        break;
    }
  };

  const renderTooltip = (value: number | undefined) => {
    if (value !== undefined) {
      return renderSuffix(value);
    } else {
      return null;
    }
  };

  return (
    <RangeSlider
      step={step}
      min={min}
      max={max}
      graduated
      progress
      value={value}    
      renderTooltip={renderTooltip}
      onChange={(value) => onChange(value)}
      renderMark={(mark) => {
        if (value?.includes(mark)) {
          return renderSuffix(mark);
        }
        return null;
      }}
    />
  );
};
